import React from "react";
import BigNumber from "bignumber.js";

const OrderRow = (props) => (
  <tr>
    <td className={`${props.class}`}>
      {/* {props.ba[0]<1?parseFloat(props.ba[0]).toFixed(8):props.ba[0]>0.1?parseFloat(props.ba[0]).toFixed(2):props.ba[0]>0.0001?parseFloat(props.ba[0]).toFixed(4):props.ba[0]>0.000001?parseFloat(props.ba[0]).toFixed(6):parseFloat(props.ba[0]).toFixed(8).toFormat(null,1)} */}

      {props.ba[0] < 0.0001 && props.ba[0] > 0.000001
        ? parseFloat(props.ba[0]).toFixed(8)
        : props.ba[0] < 0.1 && props.ba[0] > 0.0001
        ? parseFloat(props.ba[0]).toFixed(6)
        : props.ba[0] < 1 && props.ba[0] > 0.1
        ? parseFloat(props.ba[0]).toFixed(4)
        : props.ba[0] > 1
        ? parseFloat(props.ba[0]).toFixed(2)
        : parseFloat(props.ba[0]).toFixed(2)}

      {/* {new BigNumber(props.ba[0]).toFormat(null,1)} */}
    </td>
    <td>
      {/* {
                        props.ba[1]>1?parseFloat(props.ba[1]).toFixed(2):props.ba[1]>0.1?parseFloat(props.ba[1]).toFixed(2):props.ba[1]>0.0001?parseFloat(props.ba[1]).toFixed(4):props.ba[1]>0.000001?parseFloat(props.ba[1]).toFixed(6):parseFloat(props.ba[1]).toFixed(8)
                        
                        } */}

      {props.ba[1] < 0.0001 && props.ba[1] > 0.000001
        ? parseFloat(props.ba[1]).toFixed(8)
        : props.ba[1] < 0.1 && props.ba[1] > 0.0001
        ? parseFloat(props.ba[1]).toFixed(6)
        : props.ba[1] < 1 && props.ba[1] > 0.1
        ? parseFloat(props.ba[1]).toFixed(4)
        : props.ba[1] > 1
        ? parseFloat(props.ba[1]).toFixed(2)
        : parseFloat(props.ba[1]).toFixed(2)}
    </td>
    <td>
      {/* {                        
                        props.ba[1]*props.ba[0]>1?parseFloat(props.ba[1]*props.ba[0]).toFixed(2):props.ba[1]*props.ba[0]>0.1?parseFloat(props.ba[1]*props.ba[0]).toFixed(2):props.ba[1]*props.ba[0]>0.0001?parseFloat(props.ba[1]*props.ba[0]).toFixed(4):props.ba[1]*props.ba[0]>0.000001?parseFloat(props.ba[1]*props.ba[0]).toFixed(6):parseFloat(props.ba[1]*props.ba[0]).toFormat(null,1)} */}

      {props.ba[1] * props.ba[0] < 0.0001 &&
      props.ba[1] * props.ba[0] > 0.000001
        ? parseFloat(props.ba[1] * props.ba[0]).toFixed(8)
        : props.ba[1] * props.ba[0] < 0.1 && props.ba[1] * props.ba[0] > 0.0001
        ? parseFloat(props.ba[1] * props.ba[0]).toFixed(6)
        : props.ba[1] * props.ba[0] < 1 && props.ba[1] * props.ba[0] > 0.1
        ? parseFloat(props.ba[1] * props.ba[0]).toFixed(4)
        : props.ba[1] * props.ba[0] > 1
        ? parseFloat(props.ba[1] * props.ba[0]).toFixed(2)
        : parseFloat(props.ba[1] * props.ba[0])
            .toFixed(2)
            .toFormat(null, 1)}
    </td>
  </tr>
);

const ProfitLoseTable = (props) => {
  let bids = [];
  let asks = [];
  //    console.log("props.bids==",props);
  let numRowsBid = Math.min(10, props.bids.length);
  let numRowsAsk = Math.min(10, props.asks.length);
  let maxBid = BigNumber.maximum(props.bids.map((bid) => bid[0])).toFormat();
  let minAsk = BigNumber.minimum(props.asks.map((ask) => ask[0])).toFormat();

  let maxAsk = new BigNumber(minAsk)
    .minus(BigNumber.maximum(props.asks.map((ask) => ask[0])))
    .toFormat();
  let minBid = new BigNumber(maxBid)
    .minus(BigNumber.minimum(props.bids.map((bid) => bid[0])))
    .toFormat();

  for (var a = 0; a < numRowsAsk; a++) {
    asks.unshift(
      <OrderRow
        i={a}
        ba={props.asks[a]}
        diff={minAsk}
        max={maxAsk}
        class="crypt-down"
      />
    );
  }
  for (var b = 0; b < numRowsBid; b++) {
    bids.push(
      <OrderRow
        i={b}
        ba={props.bids[b]}
        diff={maxBid}
        max={minBid}
        class="crypt-up"
      />
    );
  }
  return (
    <>
      <div className="col-md-4 col_d">
        <div className="crypt-market-status mt-2">
          <div className="w_none position-relative">
            <h6 className="px-2 mb-0 py-3 text-uppercase font-weight-bold">
              Order Book
            </h6>
            <span
              className="aero_icon"
              data-toggle="collapse"
              data-target="#demo12"
            >
              <i className="las la-minus"></i>
            </span>
          </div>
          <div id="demo12" className="collapse show">
            <table className="table border_none">
              <thead>
                <tr>
                  <th scope="col">Price</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Total</th>
                </tr>
              </thead>
              <tbody>{asks}</tbody>
            </table>
            <h6 className="text-center t2t pt-2">
              {/* {console.log("props.cddddd=",props)} */}
              Last Price ${" "}
              {props.c != undefined
                ? new BigNumber(
                    props.c > 1
                      ? parseFloat(props.c).toFixed(2)
                      : props.c > 0.1
                      ? parseFloat(props.c).toFixed(2)
                      : props.c > 0.0001
                      ? parseFloat(props.c).toFixed(4)
                      : props.c > 0.000001
                      ? parseFloat(props.c).toFixed(6)
                      : parseFloat(props.c).toFixed(2)
                  ).toFormat(null, 1)
                : new BigNumber(
                    props.last > 1
                      ? parseFloat(props.last).toFixed(2)
                      : props.last > 0.1
                      ? parseFloat(props.last).toFixed(2)
                      : props.last > 0.0001
                      ? parseFloat(props.last).toFixed(4)
                      : props.last > 0.000001
                      ? parseFloat(props.last).toFixed(6)
                      : parseFloat(props.last).toFixed(2)
                  ).toFormat(null, 1)}
            </h6>
            <table className="table border_none mb-0">
              <tbody>{bids}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfitLoseTable;
